import { render, staticRenderFns } from "./ViewAllBtn.vue?vue&type=template&id=16226b5c&scoped=true&"
import script from "./ViewAllBtn.vue?vue&type=script&lang=ts&"
export * from "./ViewAllBtn.vue?vue&type=script&lang=ts&"
import style0 from "./ViewAllBtn.vue?vue&type=style&index=0&id=16226b5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16226b5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
